import { cross, distance2d, pointOnLineNearestToPoint } from "../../../geometry/operation";
import { RootState } from "../../../store/store";
import { /*useAppDispatch,*/ useAppSelector } from "../../../store/hooks";
//import { setMousePositionSnap } from "../../../store/interface";
import { useRef } from "react";
import { getConstraindedPointer } from "../util/stageManipulation";
/**
 * @param mousePosition
 * @returns Position after snapping depending on settings in store
 */
interface PointDistancePair { pos: Point2d, distance: number }

export function useSnapMousePosition() {
  //const dispatch = useAppDispatch();
  const mousePosition = useAppSelector((state: RootState) => state.interface.mouseUnmodifiedPosition);
  const snapSettings = useAppSelector((state: RootState) => state.tool.snapPoints)
  const snappingShapes = useAppSelector((state: RootState) => state.model.present.model.shapes)
  const rubberLinePoints = useAppSelector(state => state.interaction.rubberlineData.snapPoints)
  const shiftDown = useAppSelector(state => state.interaction.button.buttonHeld.shift)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const lineToHold = useRef<PointProjective | undefined>(undefined)
  const snapAngle = useAppSelector((state: RootState) => state.tool.drawSettings.snapAngle);
  const editingReferencePoint = useAppSelector((state) => state.interaction.editingReferencePoint)
  const editingMode = useAppSelector((state: RootState) => state.interaction.editorState)
  const exactPointCoords = useAppSelector(state => state.interaction.numberInput)

  const rubberlineStarted = !!rubberLinePoints[0];
  const pointReferenceStarted = !!editingReferencePoint;

  const mousePositionToUseAfterSnap = getNearestSnapPoint()
  let adjustedPoint;
  if (editingMode === 'numberInput') {

    adjustedPoint = exactPointCoords.distance;

    // } else if (editingMode === 'deltaNumberInput') {

    //   const lastIndex = rubberLinePoints.length - 1;
    //   adjustedPoint = { x: rubberLinePoints[lastIndex].x + exactPointCoords.distance.x, y: rubberLinePoints[lastIndex].y + exactPointCoords.distance.y };

  } else {

    adjustedPoint = mousePositionAdjustmentHoldingButton()
  }
  //dispatch(setMousePositionSnap(adjustedPoint));
  return adjustedPoint;


  function getNearestSnapPoint(): Point2d {
    const points = collectSnappingPoints();
    // set Snap point accordingly
    if (points[0]) {
      return points.toSorted((a, b) => a.distance - b.distance)[0].pos;
    } else {
      return mousePosition;
    }
  }
  function collectSnappingPoints() {
    const shapeSnappingpoints = snappingShapes.flatMap((p) => p.snapPoint).filter((p) => p !== undefined) as Point2d[];
    return shapeSnappingpoints
      .concat(rubberLinePoints)
      .map(createPointDistancePair)
      .filter(x => x !== undefined) as PointDistancePair[];
  }

  function createPointDistancePair(point: Point2d, _i: number): PointDistancePair | undefined {
    const distance = distance2d(mousePosition, point);

    if (distance <= snapSettings.delta * 1 / scale) {
      return { pos: point, distance: distance };
    }
  }

  function mousePositionAdjustmentHoldingButton() {
    if (shiftDown) {
      const adjustedPoint = chooseCorrection();
      if (!isCheckSnapAngle()) {
        resetLineToHold()
      }
      return adjustedPoint;
    }
    else {
      resetLineToHold();
      return mousePositionToUseAfterSnap;
    }
  }
  function resetLineToHold() {
    lineToHold.current = undefined;
  }
  function chooseCorrection() {
    if (editingReferencePoint) {
      return snapLineToNearestSnapAngle(
        mousePositionToUseAfterSnap,
        editingReferencePoint)
    }
    if (isRubberlineReferenceValid()) {
      return snapLineToNearestSnapAngle(
        mousePositionToUseAfterSnap,
        rubberLinePoints[rubberLinePoints.length - 1])
    }
    return { x: 0, y: 0 };
  }

  function isRubberlineReferenceValid() {
    return !!rubberLinePoints[rubberLinePoints.length - 1]
  }

  function snapLineToNearestSnapAngle(mouse: Point2d, refPoint: Point2d) {
    if (isCheckSnapAngle()) {
      if (!lineToHold.current) {
        lineToHold.current = makeLineToHold(mouse, refPoint);
      } else {
        return calculateThePointNearestToLine(lineToHold.current);
      }
    }
    return mouse;
  }
  function isCheckSnapAngle(): boolean {
    return rubberlineStarted || pointReferenceStarted
  }

  function makeLineToHold(mouse: Point2d, previousPoint: Point2d) {
    // Line from crossproduct of two projective point.
    const pointWithAngleConstrain = getConstraindedPointer(mouse, snapAngle, previousPoint);
    return cross(
      {
        x: pointWithAngleConstrain.x,
        y: pointWithAngleConstrain.y,
        w: 1
      },
      {
        x: previousPoint.x,
        y: previousPoint.y,
        w: 1
      }
    );
  }
  function calculateThePointNearestToLine(line: PointProjective): Point2d {
    // Projective point creation from input position.
    const inputPoint = { ...getConstraindedPointer(mousePositionToUseAfterSnap), w: 1 }
    const pointOnLine = pointOnLineNearestToPoint(inputPoint, { a: line.x, b: line.y, c: line.w });
    // Return point after homogeneous division.
    const multiplier = 1 / pointOnLine.w
    return { x: pointOnLine.x * multiplier, y: pointOnLine.y * multiplier };
  }
}

